import React, { useContext, useReducer } from 'react';
import { Action as StateAction, GameStateReducer, INITIAL_STATE as State_Initial } from './GameStateReducer';
import { Action as DifficultyAction, GameDifficultyReducer, INITIAL_STATE as Difficulty_Initial } from './GameDifficultyReducer';
import { Action as SampleAction, InitState as SampleInitState, Reducer as SampleReducer } from '../reducers/SampleReducer';

type DispatchAction =  SampleAction | StateAction | DifficultyAction;

const ContextStore = React.createContext({
  sample: SampleInitState,
  game: State_Initial,
  gameDifficulty: Difficulty_Initial,
  dispatch: (obj: DispatchAction) => { },
});

function combineDispatchs(dispatchs: Array<any>) {
  return function(obj: DispatchAction) {
    for (let i = 0; i < dispatchs.length; i++) {
      dispatchs[i](obj);
    }
  };
}

export const useGameContext = () => {
  const contextStore = useContext(ContextStore)
  return contextStore
}

export default function GameProvider({ children }: any) {
  const [sampleState, sampleDispatch] = useReducer(SampleReducer, SampleInitState);
  const [gameState, gameStateDispatch] = useReducer(GameStateReducer, State_Initial);
  const [gameDifficulty, gameDifficultyDispatch] = useReducer(GameDifficultyReducer, Difficulty_Initial);

  return (
    <ContextStore.Provider
      value={{
        sample: sampleState,
        game: gameState,
        gameDifficulty: gameDifficulty,
        dispatch: combineDispatchs([
          sampleDispatch,
          gameStateDispatch,
          gameDifficultyDispatch,
          //  oDispatch
        ])
      }}
    >
      {children}
    </ContextStore.Provider>
  );
}
